import { render, staticRenderFns } from "./ResetStudy.vue?vue&type=template&id=3c304126&scoped=true&lang=pug&"
import script from "./ResetStudy.vue?vue&type=script&lang=ts&"
export * from "./ResetStudy.vue?vue&type=script&lang=ts&"
import style0 from "./ResetStudy.vue?vue&type=style&index=0&id=3c304126&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c304126",
  null
  
)

export default component.exports